import React from "react";
import authService from "./AuthService";
import config, { getApiUrl } from "./config";
import "./CoreComponents.css";
import toast from "react-hot-toast";

type CoreComponentsProperties = {}

type CoreComponent = {
    imageReference: string
    version: string
}

type CoreComponentsState = {
    coreComponents: Array<CoreComponent>
    showUploadDialog: boolean
    dockerImage: File | null
    dockerImageReference?: string
    dockerImageVersion?: string
}

class CoreComponents extends React.Component<CoreComponentsProperties, CoreComponentsState> {
    private updateIntervalId: number | undefined;

    constructor(props: CoreComponentsProperties) {
        super(props);
        this.state = {
            coreComponents: new Array<CoreComponent>(),
            showUploadDialog: false,
            dockerImage: null,
            dockerImageReference: undefined,
            dockerImageVersion: undefined
        }
    }

    componentDidMount() {
        this.fetchCoreComponents();
        this.updateIntervalId = window.setInterval(() => this.fetchCoreComponents(), 5000);
    }

    componentWillUnmount() {
        clearInterval(this.updateIntervalId);
    }

    private uploadCoreComponent = () => {
        let data = new FormData();
        data.append('image', this.state.dockerImage!)

        if (this.state.dockerImageReference !== undefined) {
            data.append('reference', this.state.dockerImageReference)
        }

        if (this.state.dockerImageVersion !== undefined) {
            data.append('version', this.state.dockerImageVersion)
        }

        this.setState({
            showUploadDialog: false,
            dockerImage: null,
            dockerImageReference: undefined,
            dockerImageVersion: undefined
        });

        const response = fetch(getApiUrl() + "/v1/component/core/", {
            method: "POST",
            headers: [
                ["Authorization", authService.authHeader()]
            ],
            body: data
        }).then((response) => {
            if (!response.ok) {
                throw new Error("Failed to upload application component")
            }
        });

        const _ = toast.promise(response, {
            loading: 'Uploading core component...',
            success: 'Core component uploaded',
            error: 'Failed to upload core component'
        });
    }

    render() {
        return (
            <div className="CoreComponents">
                <h2>Core Components</h2>
                {this.state.coreComponents.length > 0 ? <div className="CoreComponents-list">
                    {this.state.coreComponents.map((component) => {
                        return (
                            <p className="CoreComponents-component" key={component.imageReference + component.version}>
                                {component.imageReference}<small className="CoreComponents-version">{component.version}</small>
                            </p>);
                    })}
                </div> : <div className="CoreComponents-list">
                    <div className="CoreComponents-empty">No core components found</div>
                </div>}
                <button className="Home-link" onClick={() => this.setState({showUploadDialog: true})}>Upload core
                    component
                </button>
                {this.state.showUploadDialog && <div className="CoreComponents-upload">
                    <div className="CoreComponents-upload-content">
                        <h5>Image Information</h5>
                        <div className="CoreComponents-info">
                            <label>Image Reference</label>
                            <input type={"text"} id="reference" placeholder={this.state.dockerImage?.name?.replace(".docker", "").toLowerCase() || ""}
                                   value={this.state.dockerImageReference} onChange={this.imageReferenceModified.bind(this)}/>
                            <label>Image Version</label>
                            <input type={"text"} id="version" placeholder="latest" value={this.state.dockerImageVersion} onChange={this.imageVersionModified.bind(this)}/>
                        </div>
                        <h5>Docker image (tar archive)</h5>
                        <input type="file" accept=".docker"
                               onChange={(e) => this.setState({dockerImage: e.target.files![0]})}/>
                        <div className="CoreComponent-upload-buttons">
                            <button onClick={this.uploadCoreComponent}
                                    disabled={this.state.dockerImage === null}>Upload
                            </button>
                            <button onClick={() => this.setState({
                                showUploadDialog: false,
                                dockerImage: null
                            })}>Cancel
                            </button>
                        </div>
                    </div>
                </div>}
            </div>
        );
    }

    private fetchCoreComponents() {
        fetch(getApiUrl() + "/v1/component/core/", {
            headers: [
                ["Accept", "application/json"],
                ["Authorization", authService.authHeader()]
            ]
        })
            .then(response => response.json() as Promise<CoreComponent[]>)
            .then((response) => {
                this.setState({
                    coreComponents: response
                })
            })
            .catch((error) => {
                console.error(error);
            });
    }

    private imageReferenceModified(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            dockerImageReference: event.target.value
        })
    }

    private imageVersionModified(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            dockerImageVersion: event.target.value
        })
    }
}

export default CoreComponents;
